<app-navbar></app-navbar>

<section class="min-h-[60dvh] bg-black text-white">
    <div class="w-full">
        <div class=" min-h-[50dvh] bg-no-repeat bg-cover bg-top" style="background-image: url(/assets/img/excellence/technology/technology-bg.png);">
            <div class="text-neutral-content">
                <div class="pt-40 max-w-4xl mx-auto text-center p-8">
                    <div>
                        <p class="text-4xl font-bold">{{texts.title}}</p>
                        <p class="text-base my-4 ">{{texts.subtitle[0]}}</p>
                        <p class="text-base my-4 ">{{texts.subtitle[1]}}</p>

                        <p class="mt-4 text-lg font-semibold uppercase">{{texts.more}}</p>
                    </div>
                    <div class="items-center justify-center mt-5 mx-auto">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-2 ">
                            <button class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                    transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 
                                    text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                    disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                    mx-4 transform hover:scale-105 hover:cursor-pointer" (click)="navigateToId('silenteck')">
                                <span>Silenteck™</span>
                            </button>
                            <button class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                    transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 
                                    text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                    disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                    mx-4 transform hover:scale-105 hover:cursor-pointer" (click)="navigateToId('healteck')">
                                <span>Healteck™</span>
                            </button>
                            <button class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                    transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 
                                    text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                    disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                    mx-4 transform hover:scale-105 hover:cursor-pointer" (click)="navigateToId('inktech')">
                                <span>Inktech™</span>
                            </button>
                            
                            
                        </div>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    </div>

    <div class="w-full" id="silenteck">
        <div class="min-h-[45dvh] bg-black">
            <div class="text-neutral-content text-left">
                <div class="max-w-4xl mx-auto">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 rounded-lg p-8">
                        <div class="flex flex-col justify-center">
                            <h3 class="flex text-3xl font-bold uppercase text-white">
                                <span class="mr-4">
                                    <img src="/assets/img/excellence/technology/6579d2d47dc671ad1767b299_Silenteck.svg" class="h-7 w-7" alt="" srcset="">
                                </span> 
                                {{texts.silenteck.title}}™
                            </h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">{{texts.silenteck.description[0]}}</p>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">{{texts.silenteck.description[1]}}</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <img src="/assets/img/excellence/technology/image_tire.png" alt="tire image" class="m-2 items-center w-full" />
                            
                        </div>
                        
                    </div>
                    <!--<div class="grid grid-cols-1 md:grid-cols-4 gap-4 rounded-lg p-8">
                        <div class="flex flex-col col-span-1 md:col-span-4 items-center">
                            <h3 class="text-lg text-center">Ha superado con éxito las siguientes verificaciones de resistencia: </h3>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p>KM</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">20.000</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p>KM</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">15.000</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p>KM</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">2.000</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p>KM</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">60.000</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
    </div>

    <div class="w-full" id="healteck">
        <div class="min-h-[45dvh] bg-black">
            <div class="text-neutral-content text-left">
                <div class="max-w-4xl mx-auto">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 rounded-lg p-8">
                        <div class="flex flex-col items-center">
                            <img src="/assets/img/excellence/technology/full-tire-image.png" alt="full tire" class="m-2 items-center w-4/5 md:w-full" />
                            
                        </div>
                        <div class="flex flex-col justify-center">
                            <h3 class="text-3xl font-bold uppercase text-white flex">
                                <span class="mr-4">
                                    <img src="/assets/img/excellence/technology/6579d2c3fd6d51c3a88cd5e1_Healteck.svg" class="h-7 w-7" alt="" srcset="">
                                </span> 
                                {{texts.healteck.title}}™
                            </h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">{{texts.healteck.description[0]}}</p>
     
                        </div>
                    </div>
                    <!--<div class="grid grid-cols-1 md:grid-cols-4 gap-4 rounded-lg p-8">
                        <div class="flex flex-col grid-cols-1 md:col-span-4 items-center">
                            <h3 class="text-lg text-center">Ha superado con éxito las siguientes verificaciones de validación: </h3>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p class="upper">Permiación</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">De aire</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p class="upper">Interior</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">alta velocidad</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p class="upper">Temperatura baja</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">-25ºC</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                        <div class="flex flex-col justify-center text-center">
                            <p class="upper">km</p>
                            <h3 class="text-3xl font-bold uppercase text-green-500">60.000</h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
    </div>

    <div class="w-full" id="inktech">
        <div class="min-h-[45dvh] bg-black bg-no-repeat bg-cover bg-top" style="background-image: url(/assets/img/excellence/technology/659bd657182168928f0ad12f_pattern.svg);">
            <div class="text-neutral-content text-left">
                <div class="max-w-4xl mx-auto">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 rounded-lg p-8">
                        <div class="flex flex-col justify-center">
                            <h3 class="flex text-3xl font-bold uppercase text-white">
                                <span class="mr-4">
                                    <img src="/assets/img/excellence/technology/6579d2ab6e408f71683be5c7_Inktech.svg" class="h-7 w-7" alt="" srcset="">
                                </span> 
                                {{texts.inktech.title}}™
                            </h3>
                            <p class="text-base opacity-75 mx-auto text-white mt-2">
                                {{texts.inktech.description[0]}}
                            </p>
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-2 rounded-lg p-8">
                                <div class="flex flex-col justify-center text-center">
                                    <img src="/assets/img/excellence/technology/65ba66b459db23c99b5b9ff1_inktech.png" class="w-full" alt="inktech">
                                </div>
                                <div class="flex flex-col justify-center text-center">
                                    <img src="/assets/img/excellence/technology/65ba66c5123d09f73ef2e303_tradional.png" class="w-full" alt="traditional tire">

                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col items-center">
                            <img src="/assets/img/excellence/technology/68371938dfcf1497f095583c_Inktech png4.png" alt="tire image" class="m-2 items-center w-full" />
                            
                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

</section>

<app-footer></app-footer>